// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "黄颖娜",
      "week": "1,3-5,7,11-13周",
      "add": "教学楼C座213教务"
    },
    [
      {
        "sub": "燃烧理论及设备",
        "tec": "刘耀鑫",
        "week": "1,3-7,11-12周",
        "add": "教学楼B座321能动"
      },
      {
        "sub": "劳动与创造",
        "tec": "高宇",
        "week": "2周",
        "add": "教学楼B座219能动"
      }
    ],
    [
      {
        "sub": "电机与拖动",
        "tec": "衣丽葵",
        "week": "1,3-7,11-12周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "高宇",
        "week": "2周",
        "add": "教学楼B座219能动"
      }
    ],
    {
      "sub": "热工检测技术",
      "tec": "孙卓伦",
      "week": "4-7周",
      "add": "教学楼B座219能动"
    },
    0
  ],
  "2": [
    {
      "sub": "传热学",
      "tec": "卫运钢",
      "week": "1,3-7,11-16周",
      "add": "教学楼B座325能动"
    },
    {
      "sub": "机械设计基础",
      "tec": "郭维城",
      "week": "1,3-7,11-16周",
      "add": "教学楼B座325能动"
    },
    {
      "sub": "工程伦理",
      "tec": "王若曦毛云秀",
      "week": "1,3-7,11-12周",
      "add": "教学楼B座325能动"
    },
    [
      {
        "sub": "创造性思维与创新方法",
        "tec": "高宇",
        "week": "3-7,11,16-17周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "国家安全教育",
        "tec": "黄颖娜",
        "week": "12-15周",
        "add": "教学楼C座115教务"
      }
    ],
    0
  ],
  "3": [
    [
      {
        "sub": "泵与风机",
        "tec": "关多娇",
        "week": "1,3-7,11-12周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "高宇",
        "week": "2周",
        "add": "教学楼B座219能动"
      }
    ],
    [
      {
        "sub": "电机与拖动",
        "tec": "衣丽葵",
        "week": "1,3-7,11-12周",
        "add": "教学楼C座214教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "高宇",
        "week": "2周",
        "add": "教学楼B座219能动"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "燃烧理论及设备",
      "tec": "刘耀鑫",
      "week": "1,3-7,11-12周",
      "add": "教学楼B座317能动"
    },
    {
      "sub": "机械设计基础",
      "tec": "郭维城",
      "week": "1,3-7,11-16周",
      "add": "教学楼C座311教务"
    },
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "黄颖娜",
      "week": "1,3-5,7,11-13周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "秦玲",
      "week": "11-15周",
      "add": "教学楼C座111教务"
    },
    {
      "sub": "热工检测技术",
      "tec": "孙卓伦",
      "week": "4-7周",
      "add": "教学楼B座219能动"
    }
  ],
  "5": [
    {
      "sub": "泵与风机",
      "tec": "关多娇",
      "week": "1,3-7,11-12周",
      "add": "教学楼B座325能动"
    },
    {
      "sub": "传热学",
      "tec": "卫运钢",
      "week": "1,3-7,11-16周",
      "add": "教学楼B座325能动"
    },
    [
      {
        "sub": "创造性思维与创新方法",
        "tec": "高宇",
        "week": "3-7,11,16-17周",
        "add": "教学楼B座221自控"
      },
      {
        "sub": "国家安全教育",
        "tec": "黄颖娜",
        "week": "12-15周",
        "add": "教学楼C座213教务"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
